export enum ButtonColorType {
    Default,
    Black,
    Green,
}
